var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown-item"},[_vm._v(" Diego assigned IR #1731 to you "),_c('br'),_c('small',[_vm._v("3 minutes ago")])])}]

export { render, staticRenderFns }